import { useState } from 'react';
import { ThongTinDoanhNghiep } from '@/types/schemas/thong-tin-doanh-nghiep.type';
import { CoQuanThue } from '@/types/schemas/co-quan-thue.type';

/**
 * Hook for managing search field states in the thong-tin-nop-thue feature
 *
 * @param initialData - Initial business info data (optional)
 * @returns Object with states and setters for search fields
 */
export const useSearchFieldStates = (initialData?: ThongTinDoanhNghiep) => {
  // Tax authority states
  const [taxAuthorityCuc, setTaxAuthorityCuc] = useState<CoQuanThue | null>(initialData?.ma_cqt0_data || null);
  const [taxAuthorityManagement, setTaxAuthorityManagement] = useState<CoQuanThue | null>(
    initialData?.ma_cqt_data || null
  );

  return {
    taxAuthorityCuc,
    setTaxAuthorityCuc,
    taxAuthorityManagement,
    setTaxAuthorityManagement
  };
};
